'use strict';
/* global window */

var callbackQueue = require('../lib/callbackQueue');
var callbackQueuePromise = require('../lib/callbackQueuePromise');
var Advertising = require('./advertising');
const performanceMeasure = require('../lib/performanceMeasure.js');
const adViewabilityTracking = require('./adViewabilityTracking').default;
const measure = performanceMeasure('adScripts:gamma');

window.phxConfigQueue.push(function () {
    // 'this' represents the config object
    const disableAdRendering = this.features.isEnabled('disable-ad-rendering');
    const gdpr = window.GdprStatus;
    const hasPremium = this.user.hasPremium();
    const undelayedAdCall = this.features.isEnabled('undelayed-ad-call');

    adViewabilityTracking.listenForAdViewabilityEvents();

    // We're going to wrap our Advertising queue call in a promise -- our goal
    // is to use the GdprStatus isDemonetized value, just as we would use
    // premium status, to block ads from even appearing on our site.
    gdpr.isDemonetizedSafe().then((isDemonetized) => {
        if (isDemonetized || hasPremium) {
            this.debugLog(hasPremium ? 'ADS402 Premium' : 'ADS401 Demonetized');
        }
        callbackQueue(
            'phxAdvertisingQueue',
            new Advertising({
                adServerPromise: callbackQueuePromise('phxAdServerQueue'),
                breakpointPromise: callbackQueuePromise('phxConfigQueue').then(function (config) {
                    return config.breakpoint.get();
                }),
                clientPageModelPromise: require('./clientPageModel'),
                debugLog: this.debugLog,
                document: window.document,
                forceAllSlotsEmpty: hasPremium || isDemonetized,
                adAuctionPromise: callbackQueuePromise('phxAdAuctionQueue'),
                undelayedAdCall,
                disableAdRendering,
            })
        );
    });
});

measure.end();
